import { Workflow, WorkflowConditionEnum } from "@finway-group/shared/lib/models"
import { flattenExpression } from "@finway-group/shared/lib/utils"

export const getVendorIdsFromTriggerConditions = (workflow: Workflow) => {
    const vendorIds = (workflow.triggerConditionExpression ? flattenExpression(workflow.triggerConditionExpression) : [])
        .filter((triggerCondition) => triggerCondition.condition === WorkflowConditionEnum.VENDOR && !triggerCondition.isGeneralized)
        .flatMap((triggerCondition) => triggerCondition.vendors ?? [])

    return [...new Set(vendorIds)]
}
